export default __webpack_public_path__ + "static/chess-95c4d7cecd56b471e40808fc532a59da.jpg";